
import { retry } from 'rxjs/operators';
// import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { TogetherAuctionDIPLoanDetails, TogetherAuctionDIPStageRequest } from './../models/api.models';
import { TogetherAuctionDIPEntityOperation, TogetherAuctionDIPEntityType } from './../models/enums';
import { BehaviorSubject, Observable } from 'rxjs';

import { getAPIURL, TogetherAuctionDIPEntities } from './../conf/app.conf';
import * as _ from 'lodash-es';


@Injectable()
export class NodeAPIEntityService {

  TIMEOUT: number = 150000; // Because our API is so fast..

  private entities: TogetherAuctionDIPEntities = new TogetherAuctionDIPEntities();

  doSave: BehaviorSubject<any>;


  /**
   *
   *
   * @readonly
   * @type {boolean}
   * @memberof NodeAPIEntityService
   */
  get DoSave(): boolean {
    return this.doSave.getValue();
  }


  /**
   * Creates an instance of NodeAPIService.
   * @param {HTTPClient} http
   * @memberof NodeAPIService
   */
  constructor(private http: HttpClient) {

  }

  getAllEntities(entity_type, case_id) {
    const url = this.entities.fillAPIURL(entity_type, TogetherAuctionDIPEntityOperation.Get, case_id);
    return new Observable((reqObs) => {
      let is_success = false;

      // create timestamp parameter and append to URL to prevent IE formcaching result
      const ts = +new Date();
      const fixedUrl = `${url}?ts=${ts}`;
      this.http.get(fixedUrl).pipe(
        retry(3))
        .subscribe(
          (success) => {
            try {
              reqObs.next(success);
              is_success = true;
            } catch (JSONParseError) {
              reqObs.error(JSONParseError);
            }
          },
          (error: HttpErrorResponse) => {
            reqObs.error(error);
          },
        );
      setTimeout(() => {
        if (!is_success) {
          reqObs.error({ error: new Error('Request timed out.') });
        }
      }, this.TIMEOUT);
    });
  }

  saveEntities(entity_type, case_id, entity_id, entity) {
    const url = this.entities.getURL(entity_type, TogetherAuctionDIPEntityOperation.Save, case_id, entity_id);
    //const url = this.entities.fillAPIURL(entity_type, TogetherAuctionDIPEntityOperation.Save, case_id, entity_id);
    return new Observable((reqObs) => {
      let is_success = false;
      this.http.post(url, entity)
        .subscribe(
          (success) => {
            try {
              reqObs.next(success);
              is_success = true;
            } catch (JSONParseError) {
              reqObs.error(JSONParseError);
            }
          },
          (error: HttpErrorResponse) => {
            reqObs.error(error);
          },
        );
      setTimeout(() => {
        if (!is_success) {
          reqObs.error({ error: new Error('Request timed out.') });
        }
      }, this.TIMEOUT);
    });
  }

  deleteEntities(entity_type, case_id, entity_id, sub_entity_id = null) {
    const url = this.entities.getURL(entity_type, TogetherAuctionDIPEntityOperation.Delete,
      case_id, entity_id, sub_entity_id);
    return new Observable((reqObs) => {
      let is_success = false;
      this.http.get(url).pipe(
        retry(3))
        .subscribe(
          (success) => {
            try {
              reqObs.next(success);
              is_success = true;
            } catch (JSONParseError) {
              reqObs.error(JSONParseError);
            }
          },
          (error: HttpErrorResponse) => {
            reqObs.error(error);
          },
        );
      setTimeout(() => {
        if (!is_success) {
          reqObs.error({ error: new Error('Request timed out.') });
        }
      }, this.TIMEOUT);
    });
  }

  matchAddress(address_id, ptcabscode) {
    const url = this.entities.fillAPIURLAddress(address_id, ptcabscode);
    return new Observable((reqObs) => {
      let is_success = false;
      this.http.get(url).pipe(
        retry(3))
        .subscribe(
          (success) => {
            try {
              reqObs.next(success);
              is_success = true;
            } catch (JSONParseError) {
              reqObs.error(JSONParseError);
            }
          },
          (error: HttpErrorResponse) => {
            reqObs.error(error);
          },
        );
      setTimeout(() => {
        if (!is_success) {
          reqObs.error({ error: new Error('Request timed out.') });
        }
      }, this.TIMEOUT);
    });
  }

  matchAllAddresses(caseId) {
    const url = this.entities.getURL(TogetherAuctionDIPEntityType.AddressMatch,
      TogetherAuctionDIPEntityOperation.Match,
      caseId);

    return new Observable((reqObs) => {
      let is_success = false;
      this.http.get(url).pipe(
        retry(3))
        .subscribe(
          (success) => {
            try {
              reqObs.next(success);
              is_success = true;
            } catch (JSONParseError) {
              reqObs.error(JSONParseError);
            }
          },
          (error: HttpErrorResponse) => {
            reqObs.error(error);
          },
        );
      setTimeout(() => {
        if (!is_success) {
          reqObs.error({ error: new Error('Request timed out.') });
        }
      }, this.TIMEOUT);
    });
  }

  getDIPCertificate(case_id) {
    return this.entities.getAPIURL(TogetherAuctionDIPEntityType.SubmitCertificate, TogetherAuctionDIPEntityOperation.Get, case_id).replace(':case_id', case_id);
  }

  getStage(case_id): Observable<any> {
    const self = this;
    return new Observable((reqObs) => {
      if (self.isNew(case_id) || _.isNil(case_id)) {
        reqObs.error(false);
      } else {
        this.getAllEntities(TogetherAuctionDIPEntityType.Stage, case_id)
          .subscribe(
            success => {
              try {
                reqObs.next(success['StepId']);
              } catch (OhDear) {
                reqObs.error(OhDear);
              }
            },
            error => {
              reqObs.error(error);
            },
          );
      }
    });
  }

  setStage(case_id, stage) {
    return new Observable((reqObs) => {
      const newStage = new TogetherAuctionDIPStageRequest({
        CaseId: case_id,
        StepId: stage,
      });
      this.saveEntities(TogetherAuctionDIPEntityType.Stage, case_id, null, newStage)
        .subscribe(
          (success) => {
            reqObs.next(success);
          },
          (error) => {
            reqObs.error(error);
          },
          () => {
            reqObs.complete();
          },
        );
    });
  }

  getJWT(base64string) {
    const url = this.entities.getJWTPostUrl('get');
    const data = {
      base64: base64string,
    };
    return new Observable((reqObs) => {
      return this.http.post(url, data)
        .subscribe(
          (success) => {
            reqObs.next(success);
          },
          (error) => {
            reqObs.error(error);
          },
        );
    });
  }

  verifyJWT(base64string) {
    const url = this.entities.getJWTPostUrl('verify');
    const data = {
      jwt: base64string,
    };
    return new Observable((reqObs) => {
      return this.http.post(url, data).pipe(
        retry(3))
        .subscribe(
          (success) => {
            reqObs.next(success);
          },
          (error) => {
            reqObs.error(error);
          },
        );
    });
  }

  /**
   * Tells component if it allows for a new GUID to be passed to it. (Only allows )
   * @param entity_type
   * @param case_id
   */
  allowNew(stage_name) {
    return ['tad_stage_info', 'tad_stage_apply', 'tad_stage_eligibility', 'tad_stage_loan_details'].indexOf(stage_name) !== -1;
  }

  /**
   * Tells component if it is new based upon the case_id.
   *
   * @param {any} case_id
   * @returns
   * @memberof NodeAPIEntityService
   */
  isNew(case_id) {
    return case_id === '00000000-0000-0000-0000-000000000000';
  }


}
